import { server } from "../utils/server"

const getLongUrl = (data) =>{
    return server.post('/urlShortner/auth/findLongUrl', data)
    .then((res)=>{
        return res.data;
    })
    .catch((err)=>{
        console.log(err);
        return err;
    });
}

const createShortUrl = (data) =>{
    return server.post('/urlShortner/auth/create', data)
    .then((res)=>{
        return res.data;
    })
    .catch((err)=>{
        console.log(err);
    });
}

const getShortUrl = (listingId) =>{
    return server.get(`/urlShortner/auth/getShortUrl/${listingId}`)
    .then((res)=>{
        return res.data;
    })
    .catch((err)=>{
        console.log(err);
        return err;
    });
}


const urlShortnerServices = {
    getLongUrl,
    createShortUrl,
    getShortUrl
}

export default urlShortnerServices;